import {Component, OnDestroy, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {MenuItem} from 'primeng/api';
import {STOCKS_FEATURES} from 'app/core/constants';
import {Subscription} from 'rxjs';
import {ItemNavigationService} from '../core/services/technique/item-navigation.service';
import {StocksService} from "../core/services/gestion-stock/stocks.service";
import {UtilsService} from "../core/utils/utils.service";
import {Router} from "@angular/router";

@Component({
    selector: 'yo-gestion-stocks-root',
    templateUrl: './gestion-stocks-root.component.html',
    styleUrls: ['./gestion-stocks-root.component.scss'],
    standalone: false
})
export class GestionStocksRootComponent implements OnInit, OnDestroy {

  subActivePrimaryRoute: Subscription;
  stockFeatures: MenuItem[] = [];
  selectedFeature: MenuItem;
  private subStockAlerteQuantity: Subscription;
  private subUpdateStockAlertQuantity: Subscription;

  constructor(private titleSvc:Title,
              private itemNavSvc: ItemNavigationService,
              private stockSvc: StocksService,
              private utilSvc: UtilsService,
              private router: Router) { }

  ngOnInit() {
    this.titleSvc.setTitle('Gestion des stocks');
    this.initMenu(0);
    this.activePrimaryRouteSubscription();
    this.initStockAlerteNumber();
    this.updateStockAlertQuantity();
  }

  ngOnDestroy(): void {
    this.utilSvc.unsubscribe(this.subActivePrimaryRoute);
    this.utilSvc.unsubscribe(this.subStockAlerteQuantity);
    this.utilSvc.unsubscribe(this.subUpdateStockAlertQuantity);
  }

  /**
   * selectionner l'item actif selon la route demandée
   */
  activePrimaryRouteSubscription() {
    this.subActivePrimaryRoute = this.itemNavSvc.primaryRoute$.subscribe((event) => {
      this.selectedFeature = this.itemNavSvc.activePrimaryRoute(event, this.stockFeatures);
    });
  }

  private initStockAlerteNumber() {
    this.subStockAlerteQuantity = this.stockSvc.getStockAlerteQuantity().subscribe(res => {
      this.initMenu(res.one);
    });
  }

  private initMenu(quantity: number) {
    const stockAlerteQuantity = quantity > 0 ? 'Stock minimum : ' + quantity.toString() : 'Stock minimum';
    const iconStockMinimum = quantity > 0 ? 'fa-solid fa-triangle-exclamation' : 'fas fa-cubes';
    this.stockFeatures = [
      {label:'Matières premières', icon:'fas fa-dolly', routerLink: [`stocks/${STOCKS_FEATURES.MATIERES_PREMIERES}`]},
      {label:'Mouvements', icon:'fas fa-exchange-alt', routerLink: [`${STOCKS_FEATURES.MOUVEMENTS}/grille-mouvements`]},
      {label:'Inventaire', icon:'fas fa-people-carry', routerLink: [`stocks/${STOCKS_FEATURES.INVENTAIRE}`]},
      {label: 'Historique inventaire', icon: 'fas fa-history', routerLink: [STOCKS_FEATURES.HISTORIQUE_INVENTAIRE]},
      {label: 'Validation fin de mois', icon: 'fas fa-check-circle', routerLink: [STOCKS_FEATURES.VALIDATION_INVENTAIRE]},
      {label: stockAlerteQuantity, icon:iconStockMinimum,
        routerLink: [`stocks/${STOCKS_FEATURES.STOCKS_MINIMUM}`]}
    ];
    this.selectedFeature = this.itemNavSvc.activePrimaryRoute({url: this.router.url}, this.stockFeatures);
  }

  private updateStockAlertQuantity() {
    this.subUpdateStockAlertQuantity = this.stockSvc.updateStockAlertQuantity$.subscribe(() => {
      this.initStockAlerteNumber();
    });
  }
}
